import { Grid, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import Button from '@mui/material/Button';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import TicketCommentsModal from "../DeliverableSection/comment";
import { MessageRounded } from "@material-ui/icons";
import {
    FetchFinalReport
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        hoveItem: {
            cursor: "pointer",
        },

        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    setNewReport: any;
    setValue: any;
    setOnboardingActionType: any;
    FetchFinalReport: any;
    fetchFinalReportData: any;

}
const StopsPlace: React.FC<Props> = ({
    setNewReport,
    setValue,
    setOnboardingActionType,
    FetchFinalReport,
    fetchFinalReportData
}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [page, setPage] = useState(0);
    const [openModal, setopenModal] = useState<boolean>(false);
    const [runData, setRunData] = useState<any>("")
    useEffect(() => {
        FetchFinalReport();
    }, [])

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = fetchFinalReportData.links && fetchFinalReportData.links.next.split("?")[1];
            FetchFinalReport(`?${url}`);
        } else if (newPage < page) {
            let url = fetchFinalReportData.links && fetchFinalReportData.links.previous.split("?")[1];
            FetchFinalReport(`${url === undefined ? "" : "?" + url}`);
        }
        setPage(newPage);
    };
    const handleClick = (data: any) => {
        setopenModal(true);
        setRunData(data);
    };

    return (
        <Grid container spacing={2} style={{ marginTop: 10 }}>
            <Grid container style={{ marginTop: 10 }}>
                <TableContainer
                    className={classes.tableContainer}
                    component={Paper}
                    style={{ maxHeight: "480px" }}
                >
                    <Table stickyHeader aria-label="simple table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center">Project Id</StyledTableCell>
                                <StyledTableCell align="center">Row Data Shared</StyledTableCell>
                                <StyledTableCell align="center">Row Data Shared Mode</StyledTableCell>
                                <StyledTableCell align="center">Final Report Sent</StyledTableCell>
                                <StyledTableCell align="center">Project Closer Form Sent date</StyledTableCell>
                                <StyledTableCell align="center">Data Qc Report</StyledTableCell>
                                <StyledTableCell align="center">Supplementary File</StyledTableCell>
                                <StyledTableCell align="center">Additional File</StyledTableCell>
                                <StyledTableCell align="center">Project Closer Form</StyledTableCell>
                                <StyledTableCell align="center">Bill/PO</StyledTableCell>
                                <StyledTableCell align="center">Comment</StyledTableCell>
                                <StyledTableCell align="center">Action</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        {/* dummy data  */}
                        <TableBody>
                            {fetchFinalReportData && fetchFinalReportData?.results && fetchFinalReportData?.results?.length > 0 && fetchFinalReportData?.results?.map((data: any, index: any) => {
                                return (
                                    <StyledTableRow >
                                        <StyledTableCell align="center">
                                            {data?.projectId}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.deliverable?.rawDataShared === true ? "Yes" : "No"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.deliverable?.sharingMode}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.deliverable?.finalReportSent === true ? "Yes" : "NO"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.deliverable?.closerFormSent !== null ? new Date(data?.deliverable?.closerFormSent).toLocaleString() : "NA"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.deliverable?.finalAnalysisReport !== "" ?
                                                <a href={data?.deliverable?.finalAnalysisReport} target="_blank" rel="noreferrer">View</a>
                                                : ""}
                                        </StyledTableCell><StyledTableCell align="center">
                                            {data?.deliverable?.supplementaryFile ?
                                                <a href={data?.deliverable?.supplementaryFile} target="_blank" rel="noreferrer">View</a>
                                                : "N/A"}
                                        </StyledTableCell><StyledTableCell align="center">
                                            {data?.deliverable?.additionalFile ?
                                                <a href={data?.deliverable?.additionalFile} target="_blank" rel="noreferrer">View</a>
                                                : "N/A"}
                                        </StyledTableCell><StyledTableCell align="center">
                                            {data?.deliverable?.projectCloserForm ?
                                                <a href={data?.deliverable?.projectCloserForm} target="_blank" rel="noreferrer">View</a>
                                                : "N/A"}
                                        </StyledTableCell><StyledTableCell align="center">
                                            {data?.deliverable?.billOrPo ?
                                                <a href={data?.deliverable?.billOrPo} target="_blank" rel="noreferrer">View</a>
                                                : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.deliverable?.comment === "" || data?.deliverable?.comment === undefined ?
                                                ""
                                                : <div>
                                                    <MessageRounded
                                                        onClick={() => handleClick(data)}
                                                    />
                                                </div>}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                            >
                                                <Edit onClick={() => {
                                                    setNewReport(data)
                                                    setValue(1)
                                                    setOnboardingActionType("Edit Deliverable")
                                                }} />
                                            </Button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                colSpan={3}
                                count={fetchFinalReportData?.count || 0}
                                rowsPerPage={fetchFinalReportData?.page_size}
                                page={page}
                                onPageChange={handleChangePage}
                            />
                        </TableFooter>
                    </Table>
                </TableContainer>
                <TicketCommentsModal
                    openModal={openModal}
                    setopenModal={setopenModal}
                    rundata={runData}
                />
            </Grid>
        </Grid>
    );
};
const mapStateToProps = (state: any) => ({
    fetchFinalReportData: state.GenomicsLabReducer.fetchFinalReportData,
});
export default connect(mapStateToProps, {
    FetchFinalReport,

})(StopsPlace);
